import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import ENVIRONMENTS from 'constants/enviroments';

const firebaseConfig = {
  apiKey: ENVIRONMENTS.FIREBASE.API_KEY,
  authDomain: ENVIRONMENTS.FIREBASE.AUTH_DOMAIN,
  databaseURL: ENVIRONMENTS.FIREBASE.DATABASE_URL,
  projectId: ENVIRONMENTS.FIREBASE.PROJECT_ID,
  storageBucket: ENVIRONMENTS.FIREBASE.STORAGE_BUCKET,
  messagingSenderId: ENVIRONMENTS.FIREBASE.MESSAGING_SENDER_ID,
  appId: ENVIRONMENTS.FIREBASE.APP_ID,
  measurementId: ENVIRONMENTS.FIREBASE.MEASUREMENT_ID,
};

export const myFirebase = initializeApp(firebaseConfig);

export const auth = getAuth(myFirebase);
export const firestore = getFirestore(myFirebase);

// Updated googleAuth function using modular imports
export const googleAuth = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: 'select_account',
  });
  const result = await signInWithPopup(auth, provider);
  return result;
};

// const baseDb = myFirebase.firestore();
// export const db = baseDb;
